import { dateColumn } from "..";

const createdAtColumn = (Header = "Created On", timezone) =>
  dateColumn("createdAt", Header, timezone);

export default createdAtColumn;
